import * as revueHubConnection from './revueHubConnection';
import {
  addStatusToImportStatuses,
  onNewTasksFromImport,
  updateClientTxnOpps,
  fetchAppMessages,
  clientSwitchMaintenanceMode,
  setPostAcqWorkflowGridNeedsToRefresh,
  updatePostAcqWorkflowTasks
} from '../store/actions';

const revueHubStartListener = (store, callback) => {
  revueHubConnection.connection.onclose(async () => {
    console.log('revuehub connection closed, trying to restart...');
    revueHubConnection.start();
  });

  revueHubConnection.connection.on('onServerError', (errorMsg) => {
    console.log('SignalR - onServerError', errorMsg);
  });

  revueHubConnection.connection.on('importStatusUpdate', statusDto => {
    store.dispatch(addStatusToImportStatuses(statusDto));
  });

  revueHubConnection.connection.on('newTasksFromImport', newTaskChannel => {
    store.dispatch(onNewTasksFromImport(newTaskChannel));
  });

  revueHubConnection.connection.on('updateChannelWorkflowTxnOpp', (txnOpps, actionResult) => {
    store.dispatch(updateClientTxnOpps(txnOpps, actionResult));
  });

  revueHubConnection.connection.on('titlesImported', (txnOpps, statusDto, actionResult) => {
    store.dispatch(updateClientTxnOpps(txnOpps, actionResult));
    store.dispatch(addStatusToImportStatuses(statusDto));
  });

  revueHubConnection.connection.on('newAppMessage', (appMessage) => {
    console.log('SignalR - newAppMessage', appMessage);
    store.dispatch(fetchAppMessages());
  });

  revueHubConnection.connection.on('updatedAppMessage', (appMessage) => {
    console.log('SignalR - updatedAppMessage', appMessage);
    store.dispatch(fetchAppMessages());
  });

  revueHubConnection.connection.on('maintenanceMode', (maintenanceMode) => {
    console.log('SignalR - maintenanceMode', maintenanceMode);
    store.dispatch(clientSwitchMaintenanceMode(maintenanceMode));
  });

  revueHubConnection.connection.on('newPostAcqTasksFromImport', () => {
    store.dispatch(setPostAcqWorkflowGridNeedsToRefresh(true));
  });

  revueHubConnection.connection.on('updatePostAcqWorkflowTask', (tasks, actionResult) => {
    console.log('SignalR - updatePostAcqWorkflowTask', tasks, actionResult);
    store.dispatch(updatePostAcqWorkflowTasks(tasks, actionResult));
  });
  
  revueHubConnection.start(callback);
};

export default revueHubStartListener;